import Breakpoint from '@/components/Breakpoint';
import Demo, { DemoSliderControl } from '@/components/Demo';
import VideoGif from '@/components/VideoGif';

import FoldableImage from './FoldableImage';

function FoldingDemo() {
  return (
    <>
      <Breakpoint breakpoint="smAndSmaller">
        <VideoGif
          alt="An image showing a neon city is folded up in half"
          src="/images/folding-the-dom/fold-mobile.mp4"
        />
      </Breakpoint>
      <Breakpoint breakpoint="smAndLarger">
        <Demo
          initialValues={{
            percentage: 75,
          }}
          controlPosition="top"
          customGrid={{
            gridTemplateColumns: 'min(450px, 100%)',
            justifyContent: 'center',
          }}
          controls={[
            <DemoSliderControl
              key="percentage"
              id="percentage"
              label="Folded Percentage"
              min={0}
              max={100}
            />,
          ]}
        >
          {({ percentage }) => {
            return (
              <FoldableImage
                spring
                alt="A neon alley with a Chinese sign"
                width={375}
                height={375 * (4 / 3)}
                percentage={percentage}
                src="/images/folding-the-dom/francois-hoang-china.jpg"
              />
            );
          }}
        </Demo>
      </Breakpoint>
    </>
  );
}

export default FoldingDemo;
